import z from 'zod';

export const systemAlertChannelSchema = z.enum(['email', 'slack']);

export const systemAlertSchema = z
	.object({
		id: z.string(),
		action: z.string(),
		channel: systemAlertChannelSchema,
		integrationType: z.string().optional(),
		cooldownKey: z.string().optional(),
		recipients: z.array(z.object({ id: z.string(), email: z.string() })),
		data: z.any().optional(),
		createdAt: z.coerce.date().optional(),
		updatedAt: z.coerce.date().optional(),
	})
	.describe('SystemAlert');
